<template>
  <context-menu class="contextMenu">
    <node-menu>
      <flow-menu-list-item command="copy" icon="copy"/>
      <flow-menu-list-item command="delete" icon="delete"/>
    </node-menu>
    <canvas-menu>
      <flow-menu-list-item command="undo" icon="undo"/>
      <flow-menu-list-item command="redo" icon="redo"/>
      <flow-menu-list-item command="pasteHere" icon="paste" text="Paste Here" />
    </canvas-menu>
  </context-menu>
</template>

<script>
import {
  NodeMenu, CanvasMenu, ContextMenu,
} from 'vg-editor';
import FlowMenuListItem from './FlowMenuListItem.vue';

export default {
  name: 'FlowContextMenu',
  components: {
    NodeMenu,
    CanvasMenu,
    ContextMenu,
    FlowMenuListItem,
  },
};
</script>

<style lang='scss' scoped>
.contextMenu {
  display: none;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .command {
    display: flex;
    align-items: center;
    padding: 5px 7px;
    cursor: pointer;
    transition: all 0.3s;
    user-select: none;
    margin-bottom: 5px;
    text-transform: capitalize;
  }

  .item {
    display: flex;
    align-items: center;
    padding: 5px 12px;
    cursor: pointer;
    transition: all 0.3s;
    user-select: none;
    margin-bottom: 5px;
    text-transform: capitalize;

    &:hover {
      background: #e6f7ff;
    }

    i {
      margin-right: 8px;
    }
  }
  .command {
    .item {
      display: flex;
      align-items: center;
      padding: 5px 10px;
      cursor: pointer;
      transition: all 0.3s;
      user-select: none;
      margin-bottom: 5px;
      text-transform: capitalize;

      &:hover {
        background: #e6f7ff;
      }

      i {
        margin-right: 8px;
      }
    }
    &.disable {
      .item {
        color: rgba(0, 0, 0, 0.25);
        cursor: auto;

        &:hover {
          background: #fff;
        }
      }
    }
  }
}
</style>
